import {makeTrackEvent} from './makeTrackEvent';

/**
 * The notebook actions the page reports. Gorilla reports created, deleted,
 * edited, and renamed on the same event from the mutations that complete them,
 * so a blocked Segment request cannot drop them (services/gorilla/analytics.go).
 */
export type ForgeNotebookAction = 'opened' | 'opened_in_artifacts' | 'ran';

export type ForgeNotebookLocation =
  | 'forge_page'
  | 'notebook_page'
  | 'project_page'
  | 'team_page';

export type ForgeNotebookInteractionEvent = {
  action: ForgeNotebookAction;
  location: ForgeNotebookLocation;
  notebook_id: string;
};

export const trackForgeNotebookInteraction = makeTrackEvent<
  ForgeNotebookInteractionEvent,
  {
    action: {
      description: 'the notebook interaction that completed. ran is one request to run cells from the editor: the cell run button, Shift+Enter, Cmd+Enter, run all, a markdown cell edit, or a cell the editor inserts and runs itself';
      exampleValues: ['opened', 'opened_in_artifacts', 'ran'];
    };
    location: {
      description: 'the page where the interaction started';
      exampleValues: [
        'forge_page',
        'notebook_page',
        'project_page',
        'team_page',
      ];
    };
    notebook_id: {
      description: 'the interacted-with notebook';
    };
    _description: 'Tracks Forge notebook opens, opens in artifacts, and cell runs from the page; Gorilla tracks the other actions on this event';
    _location: 'Project notebooks, team notebooks, Forge notebooks, and the notebook editor page';
    _motivation: 'Measure how notebooks are created, opened, managed, and run across their entry points';
  }
>('Forge notebooks interaction');
